import React, { createContext, useContext, useState, useEffect } from 'react';

interface ChatUnreadContextType {
  hasUnreadChat: boolean;
  setHasUnreadChat: (value: boolean) => void;
}

const ChatUnreadContext = createContext<ChatUnreadContextType>({
  hasUnreadChat: false,
  setHasUnreadChat: () => {},
});

export const ChatUnreadProvider: React.FC<{
  children: React.ReactNode;
}> = props => {
  const { children } = props;
  const [hasUnreadChat, setHasUnreadChat] = useState(false);

  useEffect(() => {
    const syncUnreadFromLocal = () => {
      try {
        const rooms = JSON.parse(localStorage.getItem('chatRooms') || '[]');
        const hasUnread = rooms.some(
          (room: any) =>
            room.hasUnreadMessage || (room.unreadCount && room.unreadCount > 0),
        );
        setHasUnreadChat(hasUnread);
      } catch {
        setHasUnreadChat(false);
      }
    };
    syncUnreadFromLocal();
    window.addEventListener('storage', syncUnreadFromLocal);
    return () => window.removeEventListener('storage', syncUnreadFromLocal);
  }, []);

  return (
    <ChatUnreadContext.Provider value={{ hasUnreadChat, setHasUnreadChat }}>
      {children}
    </ChatUnreadContext.Provider>
  );
};

export const useChatUnread = () => useContext(ChatUnreadContext);
